import { Reducer } from 'redux'
import { createReducer } from 'reduxsauce'
import { IFilter, IReportState, ReportTypes } from './types'
import {
    failure, IActionType,/*, success, failure, request, IPaginator, ISearch */
    request,
    success
} from '../root.types'
import moment from 'moment'

const INITIAL_STATE: IReportState = {
    create: {
        registered_patients: 0,
        follow_ups_total: 0,
        average_age: 0,
        standard_deviation: 0,
        state: [],
        county: [],
        age_list: [],
        case_type: [],
        risk_factors: [],
        stage_types: [],
        loading: false,
        success: false,
        error: false,
    },
    filter: {
        primaryDate: moment().toDate().toISOString(),
        secondaryDate: moment().toDate().toISOString(),
    }
}

export const loadReportRequest = (state: IReportState = INITIAL_STATE,
    action: IActionType<{ filter: IFilter }>) => {
    const { filter } = action.payload
    return { ...state, create: request({ ...state.create, filter }) }
}
export const loadReportSuccess = (state: IReportState = INITIAL_STATE,
    action: IActionType<{ data: any }>) => {
    const { data } = action.payload
    return { ...state, create: success({ ...state.create, ...data }) }
}
export const loadReportFailure = (state: IReportState = INITIAL_STATE) => {
    return { ...state, create: failure(state.create) }
}

const reducer: Reducer<IReportState> = createReducer<IReportState>(INITIAL_STATE, {
    [ReportTypes.LOAD_REPORT_REQUEST]: loadReportRequest,
    [ReportTypes.LOAD_REPORT_SUCCESS]: loadReportSuccess,
    [ReportTypes.LOAD_REPORT_FAILURE]: loadReportFailure,
})
export default reducer    